















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';

import { ProcessStats, ReviewEnum } from '../../../../types/ProcessTypes';
import ReviewStat from './ReviewStat.vue';
import { Watch } from 'vue-property-decorator';

class ReviewInfo {
  message: string;
  iconName: string;
  constructor(message: string, iconName: string) {
    this.message = message;
    this.iconName = iconName;
  }
}

@Component({ components: { ReviewStat } })
export default class ReviewStats extends Vue {

  @Getter('processModule/reviewStats') reviewStats!: ProcessStats;

  get longestHint() {
    if (!this.reviewStats) {
      return null;
    }
    const longestHint = this.reviewStats.longestHint;
    const review = longestHint.review;

    let message: string = '';
    if (review === 'BAD') {
      message = this.$t('review.body_hint_length_bad') as string;
    }
    if (review === 'OK') {
      message = this.$t('review.body_hint_length_ok') as string;
    }
    if (review === 'GOOD') {
      message = this.$t('review.body_hint_length_good') as string;
    }

    const iconName: string = this.getIconName(review);
    return new ReviewInfo(message, iconName);
  }

  get longestMilestoneTitle() {
    if (!this.reviewStats) {
      return null;
    }
    const longestMilestoneTitle = this.reviewStats.longestMilestoneTitle;
    const review = longestMilestoneTitle.review;

    let message: string = '';
    if (review === 'BAD') {
      message = this.$t('review.body_milestone_title_lenghts_bad') as string;
    }
    if (review === 'OK') {
      message = this.$t('review.body_milestone_title_lenghts_ok') as string;
    }
    if (review === 'GOOD') {
      message = this.$t('review.body_milestone_title_lenghts_good') as string;
    }

    const iconName: string = this.getIconName(review);
    return new ReviewInfo(message, iconName);
  }

  get longestMilestone() {
    if (!this.reviewStats) {
      return null;
    }
    const longestMilestone = this.reviewStats.longestMilestone;
    const review = longestMilestone.review;

    let message: string = '';
    if (review === 'BAD') {
      message = this.$t('review.body_milestone_steps_bad') as string;
    }
    if (review === 'OK') {
      message = this.$t('review.body_milestone_steps_ok') as string;
    }
    if (review === 'GOOD') {
      message = this.$t('review.body_milestone_steps_good') as string;
    }

    const iconName: string = this.getIconName(review);
    return new ReviewInfo(message, iconName);
  }

  get missingHints() {
    if (!this.reviewStats) {
      return null;
    }
    const missingHints = this.reviewStats.missingHints;
    const review = missingHints.review;

    let message: string = '';
    if (!missingHints.hints) {
      message = this.$t('review.body_milestone_steps_good') as string;
    } else {
      if (review === 'OK') {
        message = this.$t('review.body_milestone_steps_ok') as string;
      } else {
        message = this.$t('review.body_milestone_steps_bad') as string;
      }
    }

    const iconName: string = this.getIconName(review);
    return new ReviewInfo(message, iconName);
  }

  get totalNumberOfSteps() {
    if (!this.reviewStats) {
      return null;
    }
    const totalNumberOfSteps = this.reviewStats.totalNumberOfSteps;
    const review = totalNumberOfSteps.review;
    const numberOfSteps = totalNumberOfSteps.length;

    let message: string = '';
    if (numberOfSteps < 4) {
      message = this.$t('review.body_process_length_too_short') as string;
    } else if (numberOfSteps < 6) {
      message = this.$t('review.body_process_length_short') as string;
    } else if (numberOfSteps > 16) {
      message = this.$t('review.body_process_length_too_long') as string;
    } else if (numberOfSteps > 12) {
      message = this.$t('review.body_process_length_long') as string;
    } else {
      message = this.$t('review.body_process_length_good') as string;
    }

    const iconName: string = this.getIconName(review);
    return new ReviewInfo(message, iconName);
  }

  getIconName(review: ReviewEnum): string {
    if (review === ReviewEnum.GOOD) {
      return 'icon-review-good';
    }
    if (review === ReviewEnum.OK) {
      return 'icon-review-ok';
    }
    if (review === ReviewEnum.BAD) {
      return 'icon-review-bad';
    }
    return 'icon-empty';
  }
}
